import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-72eb03be")
const _hoisted_1 = { id: "summary" }
const _hoisted_2 = { class: "arrow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TRUCKS ")
const _hoisted_5 = { class: "summary-main-content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Load Zone", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Dump Zone", -1)
const _hoisted_8 = { class: "arrow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" TRUCKS ")
const _hoisted_11 = {
  key: 1,
  id: "summary-buttons"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "p-text-center p-mt-2" }
const _hoisted_14 = { class: "chart-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Load Time (min)")
], -1)
const _hoisted_16 = { class: "p-d-flex p-align-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "target_load_time" }, "Target Load Time:", -1)
const _hoisted_18 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_19 = { class: "p-inputgroup" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "min", -1)
const _hoisted_21 = { class: "p-text-center" }
const _hoisted_22 = { class: "chart-container" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Dump Time (min)")
], -1)
const _hoisted_24 = { class: "p-d-flex p-align-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "target_load_time" }, "Target Load Time:", -1)
const _hoisted_26 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_27 = { class: "p-inputgroup" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "min", -1)
const _hoisted_29 = { class: "p-text-center" }
const _hoisted_30 = { class: "chart-container" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Travel Time to Load (min)")
], -1)
const _hoisted_32 = { class: "p-d-flex p-align-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "target_travel_time" }, "Target Travel Time to Load:", -1)
const _hoisted_34 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "min", -1)
const _hoisted_37 = { class: "p-text-center" }
const _hoisted_38 = { class: "chart-container" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Travel Time to Dump (min)")
], -1)
const _hoisted_40 = { class: "p-d-flex p-align-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "target_travel_dump_time" }, "Target Travel Time to Dump:", -1)
const _hoisted_42 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_43 = { class: "p-inputgroup" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "min", -1)
const _hoisted_45 = { class: "p-text-center" }
const _hoisted_46 = { class: "chart-container" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Assumption Cycle Time (min)")
], -1)
const _hoisted_48 = { class: "p-d-flex p-align-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "target_cycle_time" }, "Target Cycle Time:", -1)
const _hoisted_50 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_51 = { class: "p-inputgroup" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "min", -1)
const _hoisted_53 = { class: "p-text-center" }
const _hoisted_54 = { class: "chart-container" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Cycle")
], -1)
const _hoisted_56 = { class: "p-d-flex p-align-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "target_cycle" }, "Target Cycle:", -1)
const _hoisted_58 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_59 = { class: "p-inputgroup" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Qty", -1)
const _hoisted_61 = { class: "p-text-center" }
const _hoisted_62 = { class: "chart-container" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Average Tons")
], -1)
const _hoisted_64 = { class: "p-d-flex p-align-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "target_cycle" }, "Target Tons:", -1)
const _hoisted_66 = { style: {"flex":"1","padding-left":"1rem"} }
const _hoisted_67 = { class: "p-inputgroup" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Qty", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ShiftKPIDialog = _resolveComponent("ShiftKPIDialog")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.shift.id && _ctx.canCalculate)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          type: "button",
          label: "Calculate",
          icon: "pi pi-percentage",
          class: "p-button-outlined p-mr-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.calculateTickets()))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Button, {
      type: "button",
      label: 'Refresh (' + _ctx.counter + ')',
      icon: "pi pi-refresh",
      class: "p-mr-2 p-button-warning p-button-outlined",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh()))
    }, null, 8, ["label"]),
    _createVNode(_component_ShiftKPIDialog, {
      visible: _ctx.displayKPIDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayKPIDialog = $event)),
      action: _ctx.kpiModalAction,
      shiftId: _ctx.shift?.id
    }, null, 8, ["visible", "action", "shiftId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", null, [
          _hoisted_4,
          _createElementVNode("strong", null, _toDisplayString(_ctx.loadedCount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.shift.zone_load?.name), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.waitingLoadCount) + " Waiting", 1)
        ]),
        _createVNode(_component_Divider),
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              class: "p-mb-2 p-button-outlined",
              label: "Total Trucks",
              badge: _ctx.totalTrucks.toString()
            }, null, 8, ["badge"]),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-mb-2 p-button-outlined",
              label: "Total Cycles",
              badge: _ctx.totalCycles.toString()
            }, null, 8, ["badge"]),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-mb-2 p-button-outlined",
              label: "Total Hours",
              badge: _ctx.hours.toString()
            }, null, 8, ["badge"]),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-mb-2 p-button-outlined",
              label: "Total Tons",
              badge: _ctx.totalTon.toString()
            }, null, 8, ["badge"]),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-mb-2 p-button-outlined",
              label: "Time per Cycle",
              badge: _ctx.timePerCycle.toString()
            }, null, 8, ["badge"]),
            _createVNode(_component_Button, {
              type: "button",
              class: "p-button-outlined",
              label: "$ / Cycle",
              badge: _ctx.fee_client.toString()
            }, null, 8, ["badge"])
          ]),
          _: 1
        }),
        _createVNode(_component_Divider),
        _createElementVNode("p", null, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.shift.zone_dump?.name), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.waitingDumpCount) + " Waiting", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("p", null, [
          _hoisted_10,
          _createElementVNode("strong", null, _toDisplayString(_ctx.dumpedCount), 1)
        ])
      ])
    ]),
    (_ctx.imForeman)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_Button, {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeKPI(_ctx.KPIMessageTypes.CHANGE_ZONE))),
            class: "p-mb-2 p-button-secondary",
            label: "CHANGE LOAD / DUMP"
          }),
          _createVNode(_component_Button, {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeKPI(_ctx.KPIMessageTypes.CHANGE_QUANTITY))),
            class: "p-mb-2 p-button-secondary",
            label: "CHANGE QUANTITY"
          }),
          _createVNode(_component_Button, {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeKPI(_ctx.KPIMessageTypes.CANCEL_TRUCKS))),
            class: "p-mb-2 p-button-danger",
            label: "CANCEL TRUCKS"
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_ctx.avgLoadChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgLoadChart.labels.length) + 'px'),
              data: _ctx.avgLoadChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_InputNumber, {
                id: "target_load_time",
                useGrouping: false,
                modelValue: _ctx.targetLoadTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.targetLoadTime = $event)),
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTarget($event, 'avgLoadChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_20
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        (_ctx.avgDumpChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgDumpChart.labels.length) + 'px'),
              data: _ctx.avgDumpChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_InputNumber, {
                id: "target_dump_time",
                useGrouping: false,
                modelValue: _ctx.targetDumpTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.targetDumpTime = $event)),
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeTarget($event, 'avgDumpChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_28
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        (_ctx.avgTravelChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgTravelChart.labels.length) + 'px'),
              data: _ctx.avgTravelChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_InputNumber, {
                id: "target_travel_time",
                useGrouping: false,
                modelValue: _ctx.targetTravelTime,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.targetTravelTime = $event)),
                onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeTarget($event, 'avgTravelChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_36
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        (_ctx.avgTravelToDumpChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgTravelToDumpChart.labels.length) + 'px'),
              type: "bar",
              data: _ctx.avgTravelToDumpChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_InputNumber, {
                id: "target_travel_dump_time",
                useGrouping: false,
                modelValue: _ctx.targetTravelToDumpTime,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.targetTravelToDumpTime = $event)),
                onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeTarget($event, 'avgTravelToDumpChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_44
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        (_ctx.avgCycleTimeChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgCycleTimeChart.labels.length) + 'px'),
              data: _ctx.avgCycleTimeChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_InputNumber, {
                id: "target_cycle_time",
                useGrouping: false,
                modelValue: _ctx.targetCycleTime,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.targetCycleTime = $event)),
                onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changeTarget($event, 'avgCycleTimeChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_52
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        (_ctx.avgCycleChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgCycleChart.labels.length) + 'px'),
              data: _ctx.avgCycleChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_InputNumber, {
                id: "target_cycle",
                useGrouping: false,
                modelValue: _ctx.targetCycle,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.targetCycle = $event)),
                onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeTarget($event, 'avgCycleChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_60
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        (_ctx.avgTonsChart)
          ? (_openBlock(), _createBlock(_component_Chart, {
              key: 0,
              type: "bar",
              style: _normalizeStyle('min-width:' + (25 * _ctx.avgTonsChart.labels.length) + 'px'),
              data: _ctx.avgTonsChart,
              options: _ctx.chartOptions
            }, null, 8, ["style", "data", "options"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_InputNumber, {
                id: "target_tons",
                useGrouping: false,
                modelValue: _ctx.targetTons,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.targetTons = $event)),
                onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changeTarget($event, 'avgTonsChart')))
              }, null, 8, ["modelValue"]),
              _hoisted_68
            ])
          ])
        ])
      ])
    ])
  ], 64))
}